// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1OjIa","checkboxCol":"Table_checkboxCol__1bpgp","emailCol":"Table_emailCol__1yC8N","actionCol":"Table_actionCol__1P8MJ"};